import { useEffect, useRef, useState } from "react";
import Icon from "components/Elements/Icon/Icon";
import Image from "components/Elements/Image/Image";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer";
import PickerPromoTooltip from "./PickerPromoTooltip";
import VerificationContainer from "components/Pages/Home/Modals/VerificationContainer";
import PickerPromoHideIconModal from "./Modals/PickerPromoHideIconModal";
import PromoIconText from "./PromoIconText";
import { useModal } from "contexts/modalContext/modalContext";
import { setLocalStorage } from "utils/globalLocalStorage";
import { useContent } from "contexts/contentContext/contentContext";
import { useUser } from "contexts/userContext/userContext";

import styles from "./pickerPromo.module.scss";

const PickerPromoIcon = ({ isPickerUser }: { isPickerUser: boolean }) => {
  const [mounted, setMounted] = useState<boolean>(false);
  const [hover, setHover] = useState<boolean>(false);

  const ref = useRef<HTMLButtonElement>(null);

  const { isLoggedIn } = useUser();
  const { getTextByKey } = useContent();
  const { setModal, closeModal } = useModal();

  const handleOpenModal = () => {
    setModal({
      modal: PickerPromoTooltip,
      container: VerificationContainer,
      props: {
        targetRef: ref.current,
      },
    });
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isLoggedIn()) {
      setMounted(false);
      // set to local storage that the promo has been closed for 24 hours
      setLocalStorage("pickerPromoClosed", new Date().getTime());
      setLocalStorage("pickerPromoShow", false);
      closeModal();
    } else {
      setModal({
        modal: PickerPromoHideIconModal,
      });
    }
  };

  return mounted ? (
    <AnimationContainer
      animationClassName="appear-animation"
      animationOn={mounted}
    >
      <button
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className={"contact item-0 " + styles.icon}
        ref={ref}
        onClick={handleOpenModal}
      >
        <div className="contact-img">
          <Image name="picker/picker-icon" ext="png" />
        </div>
        <div className={styles.textWrapper}>
          <PromoIconText text={getTextByKey("for-photographers")} />
        </div>
        {hover && (!isPickerUser || !isLoggedIn()) && (
          <div className={styles.close} onClick={handleClose}>
            <Icon name="x" white />
          </div>
        )}
      </button>
    </AnimationContainer>
  ) : null;
};

export default PickerPromoIcon;
